const divConfirmTenant = {
  access: 'Access successfully added',
  link: 'Expired link'
};

export default divConfirmTenant;
